<script setup>
import ManagePermissions from "@/components/trackers/shareActions/ManagePermissions.vue";
import {ref} from "vue";
import ManageEcosystemsAccess from "@/components/trackers/shareActions/ManageEcosystemsAccess.vue";
import {copyProfileLink} from "@/helpers";
import {useStore} from "vue2-helpers/vuex";
import {trackerTypes} from "@/constants/trackers";

const {trackerId, trackerType, isReferral, referralUrl} = defineProps(['trackerId', 'trackerType', 'isReferral', 'referralUrl']);
const emit = defineEmits(['permissionsUpdated', 'accessSettingsUpdated']);
const store = useStore();

const permissionsBlock = ref(null);
const ecosystemsBlock = ref(null);

function copyInternalLink() {
    copyProfileLink(store, 'trackers', trackerId);
}

function copyPublicLink() {
    navigator.clipboard.writeText(document.location.origin + '/public-trackers/' + (isReferral ? referralUrl : trackerId))
}

</script>

<template>
    <div>
        <b-dropdown class="dropdown-airy dropdown-airy--share icons-list" text="Share" boundary="viewport">
            <b-dropdown-item class="icons-list__share-team" @click="permissionsBlock.open()">
                Share With Team Member
            </b-dropdown-item>

            <b-dropdown-item
                v-if="trackerType === trackerTypes.PRIVATE && !store.getters.onlyNeeds"
                class="icons-list__ecosystem"
                @click="ecosystemsBlock.open()"
            >
                Share With Ecosystem
            </b-dropdown-item>

            <b-dropdown-item class="icons-list__copy" @click="copyInternalLink">
                <template v-if="trackerType === trackerTypes.PUBLIC">
                    Copy Internal Link
                </template>

                <template v-else>
                    Copy Link
                </template>
            </b-dropdown-item>

            <b-dropdown-item v-if="trackerType === trackerTypes.PUBLIC" class="icons-list__invite" @click="copyPublicLink">
                <template v-if="isReferral">Referral</template><template v-else>Public</template> Challenge Link
            </b-dropdown-item>
        </b-dropdown>

        <ManagePermissions
            ref="permissionsBlock"
            :tracker-id="trackerId"
            @saved="emit('permissionsUpdated')"
        />

        <ManageEcosystemsAccess
            ref="ecosystemsBlock"
            :tracker-id="trackerId"
            @saved="emit('accessSettingsUpdated')"
        />
    </div>
</template>

<style scoped>

</style>
